import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./TermsConditions.css"; // same CSS as Terms & Conditions

const PrivacyPolicy = () => {
  return (
    <React.Fragment>
      <Header variant="light" />
      <div className="privacy-policy">
        <Helmet>
          <title>Privacy Policy - Panmitra Online Services</title>
          <meta
            name="description"
            content="Privacy Policy of Panmitra Online Service Private Limited. Learn how we collect, use, and protect your personal information when you use our PAN card, recharge, bill payment, insurance, and API services."
          />
        </Helmet>

        <div className="body-overlay"></div>

        <main>
          {/*===== HERO AREA STARTS =======*/}
          <div
            className="about-header-area"
            style={{
              backgroundImage: "url(assets/img/bg/inner-header.png)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-7 m-auto">
                  <div className="about-inner-header heading9 text-center">
                    <h1>Privacy Policy</h1>
                    <a href="/">
                      Home <i className="fa-solid fa-angle-right" />{" "}
                      <span>Privacy Policy</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ===== Privacy Policy Content inside a Card (same class as Terms) ===== */}
          <div className="container py-5">
            <div className="terms-card p-5 bg-white rounded shadow-sm">
              <h1 className="fw-bold text-center mb-4">Privacy Policy</h1>
              <p className="text-center text-muted effective-date">
                Last Updated: 01.03.2026
              </p>

              <section className="mb-5">
                <h2>1. Introduction</h2>
                <p>
                  <strong>PANMITRA ONLINE SERVICE PRIVATE LIMITED</strong>{" "}
                  ("we", "us", "our", or "Panmitra") is committed to protecting
                  your privacy. This Privacy Policy explains how we collect,
                  use, disclose, and safeguard your information when you use our
                  website, mobile application, and services, including but not
                  limited to PAN card services, mobile/DTH recharge, utility
                  bill payments, motor insurance (POSP), API solutions, and
                  agent/distributor programs. Please read this policy carefully.
                  By accessing or using our services, you consent to the
                  practices described in this Privacy Policy.
                </p>
                <p>
                  Our registered office is located at: <br />
                  <strong>PANMITRA ONLINE SERVICE PRIVATE LIMITED</strong>
                  <br />
                  Belagavi, Karnataka - 590015, India.
                </p>
              </section>

              <section className="mb-5">
                <h2>2. Information We Collect</h2>
                <p>We may collect the following types of information:</p>
                <ul>
                  <li>
                    <strong>Personal Identification Information:</strong> Name,
                    date of birth, gender, address, email address, phone number,
                    and photograph.
                  </li>
                  <li>
                    <strong>Financial Information:</strong> Bank account
                    details, PAN card details, transaction history, and payment
                    instrument details.
                  </li>
                  <li>
                    <strong>Technical Information:</strong> IP address, browser
                    type, device information, operating system, and usage data
                    (pages visited, time spent, etc.).
                  </li>
                  <li>
                    <strong>KYC Documents:</strong> Copies of identification
                    documents (Voter, PAN, etc.) provided for verification
                    purposes.
                  </li>
                  <li>
                    <strong>Location Information:</strong> With your consent, we
                    may collect your precise location to prevent fraud and
                    ensure compliance.
                  </li>
                </ul>
              </section>

              <section className="mb-5">
                <h2>3. How We Collect Information</h2>
                <p>We collect information through:</p>
                <ul>
                  <li>
                    Registration and account creation forms (for agents,
                    distributors, and users).
                  </li>
                  <li>
                    Transaction forms when you use our services (PAN
                    applications, recharges, bill payments, insurance).
                  </li>
                  <li>KYC submission processes.</li>
                  <li>API integration requests and documentation access.</li>
                  <li>Cookies and similar tracking technologies.</li>
                  <li>Customer support interactions (phone, email, chat).</li>
                  <li>
                    Third‑party sources, such as banks, payment gateways, or
                    government portals, with your consent or as required for
                    service delivery.
                  </li>
                </ul>
              </section>

              <section className="mb-5">
                <h2>4. Use of Your Information</h2>
                <p>
                  We use the collected information for the following purposes:
                </p>
                <ul>
                  <li>
                    To provide, maintain, and improve our services (PAN card,
                    recharge, bill payments, insurance, APIs).
                  </li>
                  <li>
                    To process transactions and send transaction confirmations.
                  </li>
                  <li>
                    To verify your identity and comply with KYC/AML regulations.
                  </li>
                  <li>
                    To communicate with you about your account, updates,
                    promotional offers (with opt‑out option), and important
                    notices.
                  </li>
                  <li>
                    To detect, prevent, and address fraud, security breaches, or
                    technical issues.
                  </li>
                  <li>
                    To comply with legal obligations and enforce our Terms &
                    Conditions.
                  </li>
                  <li>To analyze usage trends and improve user experience.</li>
                  <li>
                    To facilitate API integrations and provide developer
                    support.
                  </li>
                </ul>
              </section>

              <section className="mb-5">
                <h2>5. Sharing of Information</h2>
                <p>We may share your information with:</p>
                <ul>
                  <li>
                    <strong>Service Providers:</strong> Third‑party vendors who
                    assist us in operating our platform, processing payments,
                    conducting KYC, providing customer support, or managing
                    APIs. These parties are bound by confidentiality agreements.
                  </li>
                  <li>
                    <strong>Financial Institutions and Partners:</strong> Banks,
                    payment aggregators, utility companies, insurance providers,
                    and government agencies (e.g., NSDL, UTI) necessary to
                    execute your transactions.
                  </li>
                  <li>
                    <strong>Regulatory Authorities:</strong> Government bodies
                    or law enforcement agencies when required by law or to
                    protect our rights.
                  </li>
                  <li>
                    <strong>Business Transfers:</strong> In the event of a
                    merger, acquisition, or asset sale, your information may be
                    transferred to the successor entity.
                  </li>
                </ul>
                <p>
                  We do not sell, rent, or trade your personal information to
                  third parties for marketing purposes.
                </p>
              </section>

              <section className="mb-5">
                <h2>6. Data Security</h2>
                <p>
                  We implement appropriate technical and organizational measures
                  to protect your personal data against unauthorized access,
                  alteration, disclosure, or destruction. These measures include
                  encryption, firewalls, secure servers, and access controls.
                  However, no method of transmission over the Internet or
                  electronic storage is 100% secure, and we cannot guarantee
                  absolute security. You are responsible for maintaining the
                  confidentiality of your account credentials.
                </p>
              </section>

              <section className="mb-5">
                <h2>7. Retention of Data</h2>
                <p>
                  We retain your personal information for as long as necessary
                  to fulfill the purposes outlined in this Privacy Policy,
                  unless a longer retention period is required or permitted by
                  law (e.g., for regulatory, tax, or legal reasons). KYC
                  documents and transaction records are retained as per
                  applicable laws.
                </p>
              </section>

              <section className="mb-5">
                <h2>8. Your Rights</h2>
                <p>You have the right to:</p>
                <ul>
                  <li>
                    Access and obtain a copy of your personal data held by us.
                  </li>
                  <li>Request correction of inaccurate or incomplete data.</li>
                  <li>
                    Request deletion of your data, subject to legal obligations.
                  </li>
                  <li>
                    Withdraw consent at any time, where processing is based on
                    consent.
                  </li>
                  <li>
                    Lodge a complaint with a supervisory authority (e.g., Data
                    Protection Authority).
                  </li>
                </ul>
                <p>
                  To exercise these rights, please contact us at the details
                  provided in Section 13.
                </p>
              </section>

              <section className="mb-5">
                <h2>9. Cookies and Tracking Technologies</h2>
                <p>
                  We use cookies and similar technologies to enhance your
                  experience, analyze site traffic, and personalize content. You
                  can set your browser to refuse cookies, but some features of
                  our platform may not function properly. For more details, see
                  our <Link to="/cookie-policy">Cookie Policy</Link>.
                </p>
              </section>

              <section className="mb-5">
                <h2>10. Third‑Party Links</h2>
                <p>
                  Our platform may contain links to third‑party websites or
                  services (e.g., payment gateways, government portals). We are
                  not responsible for the privacy practices or content of those
                  third parties. We encourage you to read their privacy policies
                  before providing any information.
                </p>
              </section>

              <section className="mb-5">
                <h2>11. Children's Privacy</h2>
                <p>
                  Our services are not intended for individuals under the age of
                  18. We do not knowingly collect personal information from
                  minors. If you become aware that a minor has provided us with
                  personal data, please contact us, and we will take steps to
                  delete such information.
                </p>
              </section>

              <section className="mb-5">
                <h2>12. Changes to This Privacy Policy</h2>
                <p>
                  We may update this Privacy Policy from time to time. Any
                  changes will be posted on this page with an updated "Last
                  Updated" date. We encourage you to review this policy
                  periodically. Your continued use of our services after any
                  modifications indicates your acceptance of the revised policy.
                </p>
              </section>

              <section className="mb-5">
                <h2>13. Contact Us & Grievance Officer</h2>
                <p>
                  If you have any questions, concerns, or requests regarding
                  this Privacy Policy or our data practices, you may contact us
                  at:
                </p>
                <address>
                  <strong>PANMITRA ONLINE SERVICE PRIVATE LIMITED</strong>
                  <br />
                  Belagavi, Karnataka - 590015, India
                  <br />
                  Phone: +91 9632-456-111
                  <br />
                  Email: panmitra121@gmail.com
                  <br />
                  Web: https://instantpanmitra.com
                </address>
                <p className="mt-3">
                  <strong>Grievance Officer:</strong> For any complaints or
                  grievances regarding data privacy, please email us at
                  panmitra121@gmail.com. The Grievance Officer shall acknowledge
                  the complaint within 48 hours and resolve it within 30 days as
                  per applicable laws.
                </p>
              </section>

              <div className="text-center mt-5">
                <p className="mt-3 text-muted">
                  By using our services, you acknowledge that you have read and
                  understood this Privacy Policy.
                </p>
              </div>
            </div>
          </div>
        </main>
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default PrivacyPolicy;
